import type { ApiEnv } from '../cognito/config';

/** localStorage keys used by Discover SPAs and MFEs. */
export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'HELIXA_ACCESS_TOKEN',
  ID_TOKEN: 'HELIXA_ID_TOKEN',
  REFRESH_TOKEN: 'HELIXA_REFRESH_TOKEN',
} as const;

/**
 * Unscoped cookie names used before env isolation.
 * Cleared on logout for hygiene; never read for handoff.
 */
export const LEGACY_COOKIE_NAMES = {
  ACCESS_TOKEN: 'accessToken',
  ID_TOKEN: 'idToken',
  REFRESH_TOKEN: 'refreshToken',
} as const;

/** @deprecated Prefer getSsoCookieNames(apiEnv). Kept for callers that still import COOKIE_NAMES. */
export const COOKIE_NAMES = LEGACY_COOKIE_NAMES;

export const SSO_COOKIE_DOMAIN = '.helixa.ai';

const KNOWN_API_ENVS: ApiEnv[] = ['develop', 'staging', 'production'];

export const normalizeApiEnv = (apiEnv: string | undefined | null): ApiEnv => {
  if (apiEnv && (KNOWN_API_ENVS as string[]).includes(apiEnv)) {
    return apiEnv as ApiEnv;
  }

  return 'develop';
};

/** Env-scoped SSO cookie names so staging/prod/develop do not overwrite each other. */
export const getSsoCookieNames = (apiEnv: string | undefined | null) => {
  const env = normalizeApiEnv(apiEnv);

  return {
    ACCESS_TOKEN: `accessToken_${env}`,
    ID_TOKEN: `idToken_${env}`,
    REFRESH_TOKEN: `refreshToken_${env}`,
  } as const;
};
